import React, { Fragment } from 'react'
import injectSheet from 'react-jss'
import styles from './create-dialog.styles'
import {
  Modal,
  ModalHeader,
  ModalFooter,
  ModalContent
} from 'pobble-components/dist/modal'
import Button from 'pobble-components/dist/button'
import { FormSupplier } from '../slide-form/slide-form'

const SuccessCriteriaSlideCreateDialog = React.memo(
  ({ classes, modalOpened, onClose, onSubmit, body, pending }) => (
    <Modal closeButton isOpen={modalOpened} requestClose={onClose}>
      <ModalHeader>Create success criteria slide</ModalHeader>
      <FormSupplier
        onSubmit={onSubmit}
        defaultValues={{ title: 'Success criteria' }}>
        {({ slideForm }) => (
          <Fragment>
            <ModalContent legacy>{slideForm}</ModalContent>
            <ModalFooter alignRight childrenGap>
              <Button tall simple action={onClose}>
                Cancel
              </Button>
              <Button tall type="submit">
                Save
              </Button>
            </ModalFooter>
          </Fragment>
        )}
      </FormSupplier>
    </Modal>
  )
)

export default injectSheet(styles)(SuccessCriteriaSlideCreateDialog)
